module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-regular-400.2b8a79b1.svg";